// IN COLUMN SETTINGS
//  {
//   name: 'sdDebitCashBalance',
//   label: 'SD Debit Cash Balance',
//   type: 'quantity', //custom quantity/amount/percentage/date/dateTime
//   addFooter: true, //custom true/false
// },

//pending: filter retain values

import { FormGroup, TextField, Checkbox, Tooltip, IconButton } from '@material-ui/core';
import React, { useEffect, useState, Fragment } from 'react';
import moment from 'moment-timezone';
import MUIDataTable from 'mui-datatables';
import { MuiThemeProvider } from '@material-ui/core/styles';
import tableTheme from './TableStyle';
import TableBodyFooter from './TableBodyFooter';
import TableViewCol from './TableViewCol';
import CsvDownload from './CsvDownload';
import ServerSideTableBodyFooter from './ServerSideTableBodyFooter';
import AutoCompleteFilter from './../AutoComplete/AutoCompleteFilter';

import {
  Save as SaveIcon,
  CheckCircle as CheckCircleIcon,
  Refresh as RefreshIcon,
  Cancel as CrossIcon,
} from '@material-ui/icons';

import { usePageContext } from '../../context/PageContext';

import {
  getArrayKeyIndex,
  getArrayIndex,
  moveArrayIndex,
  tableDateTimeSortCompare,
  tableDateSortCompare,
  tableAmountSortCompare,
  tablePercentageSortCompare,
  tableQuantitySortCompare,
} from '../../lib/utils/utils';
import {
  formatPbDate,
  formatCurrency,
  formatCurrencySymbol,
  formatPercentage,
  formatQty,
  formatStatus,
  twelveHourTimeFormat,
  formatDuration,
} from '../../lib/fmt2';
import {
  protoTimeSpanObjectToString,
  protoDateObjectToDate,
  protoDatTimeObjectToDate,
  dateStringToDate,
  stringToDateTime,
  protoDatTimeObjectToDateWithMilliseconds,
} from '../../services/ConvertService';
import { getVisibleColumns } from './TableSettings';
import authSvc from '../../services/AuthService';
import {
  updateTableSettings,
  readTableSettings,
  createTableSettings,
  deleteTableSettings,
  readRoleTableSettings,
  readTableColumns,
  createTableColumns,
  updateTableColumns,
  updateRoleTableSettings,
} from '../../services/TableSettingsService';
import { notifySuccess } from '../Messages/Notification';
import { NoteCustomFilterListOptions, NoteFilterOptions } from './TableCustomFilter';

import { ListCustomFilterListOptions, ListFilterOptions } from './TableListCustomFilter';

export const columnType = {
  date: 'date',
  dateTime: 'dateTime',
  quantity: 'quantity',
  quantity6Decimal: 'quantity6Decimal',
  quantity16Decimal: 'quantity16Decimal',
  percentage: 'percentage',
  amount: 'amount', // 2 decimals
  amountCurrency: 'amountCurrency', // 2 decimals
  price: 'price', // 6 decimals
  priceCurrency: 'priceCurrency', // 6 decimals
  amountBalance: 'amountBalance',
  text: 'text',
  buttons: 'buttons',
  bool: 'bool',
  status: 'status',
  note: 'note',
  time: 'time',
  duration: 'duration',
  list: 'list',
  timeWithMilliseconds: 'timeWithMilliseconds',
};

// Export to temporary fix the row executable buttons
// having different data index when being filter
// this happens because rows have different index/data when filtered
export let tempFilteredRows = [];

const defaultModalColumnChangesData = {
  open: false,
  newSettings: '',
  oldSettings: '',
};

export default function CleanUpTable({
  data: rows,
  columns,
  title,
  options,
  footerData,
  onSearch,
  pagination,
  setPagination,
  getCsvData,
  additionalCell,
  handleCustomSearch, //To Properly set serverside custom searching on tables
  modalTable, //for now, this is only applicable for activity page since we're reusing table component with caching
  origVisibleColumns,
  origColumnOrder,
  componentName,
}) {
  const { customFieldName } = usePageContext();
  const [filterList, setFilterList] = useState({});
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [serverSideSearch, setServerSideSearch] = useState('');
  const [visibleColumns, setVisibleColumns] = React.useState(origVisibleColumns);
  const sortedColumns = sortColumnSettings([...columns]);
  const [isReset, setIsReset] = useState(false);
  const [modalColumnChangesData, setModalColumnChangesData] = useState(
    defaultModalColumnChangesData
  );

  const filterRows = () => {
    const filterKeys = Object.keys(filterList);
    if (!filterKeys.length) {
      return rows;
    }

    const filtered = rows.filter((r) => {
      let ok = true;
      filterKeys.forEach((key) => {
        if (filterList[key] !== r[key]) {
          ok = false;
          return false;
        }
      });
      return ok;
    });

    return filtered;
  };

  tempFilteredRows = filterRows();

  // FOR SERVER SIDE CUSTOM SEARCH
  if (serverSideSearch && options.serverSide && tempFilteredRows.length) {
    tempFilteredRows = serverSideCustomSearch(
      serverSideSearch,
      tempFilteredRows,
      visibleColumns,
      columns
    );
    //handleCustomSearch is a function to properly set filtered data by custom search.
    handleCustomSearch && handleCustomSearch(tempFilteredRows, serverSideSearch);
  }
  const [rowsSelected] = React.useState([]);
  const [columnOrder, setColumnOrder] = React.useState(
    columns.map((a, index) => {
      return index;
    })
  );

  const user = authSvc.getCurrentUser() || {};
  const params = {
    title: title,
    userId: user.UserId,
    roleId: user.RoleId,
    visibleColumns: origVisibleColumns,
    columnOrder: origColumnOrder,
    componentName: componentName,
  };

  const [openCsvDownload, setOpenCsvDownload] = React.useState(false);
  const columnSettings = getColumnSettings(
    visibleColumns,
    tempFilteredRows,
    options,
    columns
  );

  const [clientSideRowsPerPage, setClientSideRowsPerPage] = React.useState(100);

  const optionSettings = getOptionSettings(
    options,
    columns,
    tempFilteredRows,
    title,
    columnOrder,
    setColumnOrder,
    visibleColumns,
    setVisibleColumns,
    rowsSelected,
    params,
    footerData,
    pagination,
    setPagination,
    setOpenCsvDownload,
    setFilterList,
    additionalCell,
    setServerSideSearch,
    clientSideRowsPerPage,
    setClientSideRowsPerPage,
    isFilterActive,
    setIsFilterActive,
    columnSettings,
    componentName,
    isReset,
    setIsReset
  );

  useEffect(() => {
    if (setPagination) {
      setPagination({
        count: 0,
        rowsPerPage: 100,
        pageNo: 0,
        reload: false,
        sortName: '',
        sortDirection: '',
        filterNames: [],
        filterValues: [],
      });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (pagination) {
      if (pagination.reload) {
        onSearch(true, modalTable);
      }
    }
    // eslint-disable-next-line
  }, [pagination]);

  useEffect(
    () => {
      if (componentName) {
        compareColumnsToDB();
      }
      loadIntialTableSetting();
    },
    // eslint-disable-next-line
    []
  );

  const loadIntialTableSetting = async () => {
    if (!componentName) {
      return loadUserInitialSettings();
    }

    let userSettings;
    try {
      userSettings = await readTableSettings(params);
      updateColumns(userSettings);
    } catch (error) {
      console.log('no user column settings');
    }

    const roleSettings = await readRoleTableSettings(params);
    if (!userSettings) {
      try {
        if (roleSettings.roleTableSettingsId !== 0) {
          updateColumns(roleSettings);
        }
      } catch (error) {
        console.log('no role column settings');
        setVisibleColumns(getVisibleColumns(columns));
        setColumnOrder(getColumnOrder(columns, columnSettings));
      }
    }
  };

  const compareColumnsToDB = async () => {
    const newCols = columns.map((col) => {
      return {
        name: col.name,
        label: col.label,
        options:
          col.options.display === false
            ? {
                display: col.options.display,
              }
            : undefined,
      };
    });

    const str = JSON.stringify(newCols);
    try {
      let strColumns;

      strColumns = await readTableColumns({
        componentName: componentName,
        tableType: 'Main',
      });

      if (strColumns?.columns === '') {
        strColumns = await createTableColumns({
          componentName: componentName,
          columns: str,
          tableType: 'Main',
        });
      }

      if (strColumns) {
        if (str !== strColumns.columns || strColumns === '') {
          // open modal column changes
          setModalColumnChangesData({
            open: true,
            oldSettings: strColumns.columns,
            newSettings: str,
          });

          const res = await updateTableColumns({
            componentName: componentName,
            columns: str,
            tableType: 'Main',
          });
          if (res) {
            // Save to role table setting
            const prm = {
              componentName: componentName,
              roleId: user.RoleId,
              visibleColumns: getVisibleColumns(columns),
              columnOrder: columnOrder,
            };
            await deleteTableSettings(params);
            await updateRoleTableSettings(prm);
          }
          setIsReset(true);
        }
      }
    } catch (err) {
      console.log('columns are not mapped');
    }
  };

  useEffect(() => {
    if (isReset) {
      loadIntialTableSetting();
      notifySuccess('Table setting has been reset.');
      setIsReset(false);
    }
    // eslint-disable-next-line
  }, [isReset]);

  const loadUserInitialSettings = () => {
    readTableSettings(params)
      .then(function (res) {
        const currentColumnCount = params.columnOrder.length;
        const saveColumnCount = res.columnOrder.split(',').length;

        setVisibleColumns(
          currentColumnCount === saveColumnCount
            ? res.visibleColumns.split(',')
            : params.visibleColumns
        );
        setColumnOrder(
          currentColumnCount === saveColumnCount
            ? res.columnOrder.split(',')
            : params.columnOrder
        );
      })
      .catch(() => {
        // Create table for settings when none is found
        params.visibleColumns = getVisibleColumns(columns);
        params.columnOrder = getColumnOrder(columns, columnSettings);
        createTableSettings(params)
          .then(function (res) {
            setVisibleColumns(res.tableSettings.visibleColumns.split(','));
            setColumnOrder(res.tableSettings.columnOrder.split(','));
          })
          .catch(() => {
            console.error('error creating user table setting');
            return;
          });
        console.log('user table setting not found');
        return;
      });
  };

  const updateColumns = async (settings) => {
    const currentColumnCount = params.columnOrder.length;
    const saveColumnCount = settings.columnOrder.split(',').length;

    setVisibleColumns(
      currentColumnCount === saveColumnCount
        ? settings.visibleColumns.split(',')
        : params.visibleColumns
    );
    setColumnOrder(
      currentColumnCount === saveColumnCount
        ? settings.columnOrder.split(',')
        : params.columnOrder
    );
  };

  const getFormattedCsvData = async () => {
    // const types = getColumnTypes(cols, columns);
    const raw = await getCsvData();
    if (!raw.length) {
      return [];
    }

    let keys = Object.keys(raw[0]);
    moveArrayIndex(keys, getArrayIndex(keys, 'accountId'), 0);
    moveArrayIndex(keys, getArrayIndex(keys, 'trnsId'), 0);

    let columnTypes = {};
    keys.forEach((key) => {
      const set = getColumnSettingsByName(columnSettings, key);
      columnTypes[key] = set ? set.type : undefined;
    });

    const formatted = raw.map((data) => {
      let r = {};
      keys.forEach((key) => {
        //Do not format price to 2 digits when downloading has to be 6 digits for real value
        if (['price'].includes(key)) {
          r[key] = getColumnValue(columnType.amount6Decimal, data[key]);
        } else {
          r[key] = getColumnValue(columnTypes[key], data[key]);
        }
      });

      return r;
    });

    return formatted;
  };

  // UI CUSTOM FIELD NAMES
  const columnSettingsRenamed = columnSettings.map((col) => {
    if (col.label) {
      return {
        ...col,
        label: customFieldName(col.label),
      };
    }
    return col;
  });

  return (
    <React.Fragment>
      {openCsvDownload && (
        <CsvDownload
          getData={getFormattedCsvData}
          filename={getCsvFileName(title)}
          open={openCsvDownload}
          onClose={() => {
            setOpenCsvDownload(false);
          }}
        />
      )}
      <MuiThemeProvider theme={tableTheme(title)}>
        <MUIDataTable
          title={title}
          data={tempFilteredRows}
          columns={columnSettingsRenamed}
          options={optionSettings}
          componentName={componentName}
          components={{
            Checkbox: CustomCheckbox,
            TableViewCol: TableViewCol,
          }}
        />
      </MuiThemeProvider>
    </React.Fragment>
  );
}

const CustomCheckbox = (props) => {
  const bgColor = props['data-description'] === 'row-select-header' ? '' : 'whitesmoke';

  return (
    <Checkbox
      style={{
        backgroundColor: bgColor,
      }}
      {...props}
    />
  );
};

const getColumnSettings = (visibleColumns, rows, options, sortedColumns) => {
  return sortedColumns.map((col) => {
    col.options = col.options || {};

    //visibility state
    if (visibleColumns.includes(col.name)) {
      col.options.display = true;
    } else if (col.options.display !== 'excluded') {
      col.options.display = false;
    }
    switch (col.type) {
      case columnType.amountBalance:
        col.options.customBodyRenderLite = (dataIndex) => {
          const value = rows[dataIndex][col.name];
          const currency = col.currency;
          const formattedValue = formatCurrencySymbol(value, currency, 2);
          return (
            <div align="right" style={{ color: value < 0 && '#f44336' }}>
              {formattedValue}
            </div>
          );
        };
        break;
      case columnType.date:
        if (!options.serverSide) {
          col.options.filterType = 'custom';
          col.options.filterList = [];
          col.options.customFilterListOptions = getCustomFilterListOptions(col);
          col.options.filterOptions = {
            names: [],
            logic(stringValue, filters) {
              const from = dateStringToDate(filters[0]);
              const to = dateStringToDate(filters[1]);
              const value = protoDateObjectToDate(stringValue);

              if (from && to) {
                return !(value >= from && value <= to);
              } else if (from) {
                return !(value >= from);
              } else if (to) {
                return !(value <= to);
              }

              return false;
            },
            display: (filterList, onChange, index, column) => {
              return dateRangeTemplate(filterList, onChange, index, column, col, 'date');
            },
          };
        } else {
          col.options.filter = false;
        }
        col.options.filter = false;
        col.options.customBodyRenderLite = (dataIndex) => {
          return (
            <div align="right">{getColumnValue(col.type, rows[dataIndex][col.name])}</div>
          );
        };

        col.options.sortCompare = tableDateSortCompare;
        break;
      case columnType.dateTime:
        if (!options.serverSide) {
          col.options.filterType = 'custom';
          col.options.filterList = [];
          col.options.customFilterListOptions = getCustomFilterListOptions(col);
          col.options.filterOptions = {
            fullWidth: true,
            names: [],
            logic(stringValue, filters) {
              const from = stringToDateTime(filters[0]);
              const to = stringToDateTime(filters[1]);
              const value = protoDatTimeObjectToDate(stringValue);

              if (from && to) {
                return !(value >= from && value <= to);
              } else if (from) {
                return !(value >= from);
              } else if (to) {
                return !(value <= to);
              }

              return false;
            },
            display: (filterList, onChange, index, column) => {
              return dateRangeTemplate(
                filterList,
                onChange,
                index,
                column,
                col,
                'datetime-local'
              );
            },
          };
        } else {
          col.options.filter = false;
        }
        col.options.filter = false;
        if (!col.options.customBodyRenderLite && rows?.length) {
          col.options.customBodyRenderLite = (dataIndex) => {
            return getColumnValue(col.type, rows[dataIndex][col.name]);
          };
        }

        col.options.sortCompare = tableDateTimeSortCompare;
        break;
      case columnType.amount:
        col.options.filterType = 'custom';
        col.options.customFilterListOptions = {
          render: (v) => {
            return v.toString() !== '' ? `${col.label}: ${v.toString()}` : [];
          },
          update: (filterList, filterPos, index) => {
            if (filterPos === 0) {
              filterList[index].splice(filterPos, 1, '');
            } else if (filterPos === 1) {
              filterList[index].splice(filterPos, 1);
            } else if (filterPos === -1) {
              filterList[index] = [];
            }
            return filterList;
          },
        };
        col.options.filterOptions = {
          logic: (value, filters) => {
            if (filters.length > 0 && filters[0] !== '') {
              return !filters.includes(value);
            }
            return false;
          },
          display: (filterList, onChange, index, column, filterData) => {
            return (
              <AutoCompleteFilter
                freeSolo={true}
                name={column.name}
                label={column.label}
                value={filterList[index][0] || ''}
                onChange={(event) => {
                  filterList[index][0] = event.currentTarget.value;
                  onChange(filterList[index], index, column);
                }}
                options={filterData[index]}
              />
            );
          },
        };
        col.options.customBodyRenderLite = (dataIndex) => {
          if (!rows.length || !rows[dataIndex]) {
            return '';
          }
          const value = rows[dataIndex][col.name];
          const formattedValue = getColumnValue(col.type, value);

          return (
            <div align="right" style={{ color: value < 0 && '#f44336' }}>
              {formattedValue}
            </div>
          );
        };

        col.options.sortCompare = tableAmountSortCompare;
        break;
      case columnType.amountCurrency:
        col.options.customBodyRenderLite = (dataIndex) => {
          const value = rows[dataIndex][col.name];
          const currency = rows[dataIndex]?.currency;
          const formattedValue = formatCurrencySymbol(value, currency, 2);
          return (
            <div align="right" style={{ color: value < 0 && '#f44336' }}>
              {formattedValue}
            </div>
          );
        };
        break;
      case columnType.price:
        col.options.filterType = 'custom';
        col.options.customFilterListOptions = {
          render: (v) => {
            return v.toString() !== '' ? `${col.label}: ${v.toString()}` : [];
          },
          update: (filterList, filterPos, index) => {
            if (filterPos === 0) {
              filterList[index].splice(filterPos, 1, '');
            } else if (filterPos === 1) {
              filterList[index].splice(filterPos, 1);
            } else if (filterPos === -1) {
              filterList[index] = [];
            }
            return filterList;
          },
        };
        col.options.filterOptions = {
          logic: (value, filters) => {
            if (filters.length > 0 && filters[0] !== '') {
              return !filters.includes(value);
            }
            return false;
          },
          display: (filterList, onChange, index, column, filterData) => {
            return (
              <AutoCompleteFilter
                freeSolo={true}
                name={column.name}
                label={column.label}
                value={filterList[index][0] || ''}
                onChange={(event) => {
                  filterList[index][0] = event.currentTarget.value;
                  onChange(filterList[index], index, column);
                }}
                options={filterData[index]}
              />
            );
          },
        };
        col.options.customBodyRenderLite = (dataIndex) => {
          const value = rows[dataIndex][col.name];
          const formattedValue = getColumnValue(col.type, value);

          return (
            <div align="right" style={{ color: value < 0 && '#f44336' }}>
              {formattedValue}
            </div>
          );
        };

        col.options.sortCompare = tableAmountSortCompare;
        break;

      case columnType.priceCurrency:
        col.options.customBodyRenderLite = (dataIndex) => {
          const value = rows[dataIndex][col.name];
          const currency = rows[dataIndex]?.currency;
          const formattedValue = formatCurrencySymbol(value, currency, 6);
          return (
            <div align="right" style={{ color: value < 0 && '#f44336' }}>
              {formattedValue}
            </div>
          );
        };
        break;
      case columnType.percentage:
        col.options.filterType = 'custom';
        col.options.customFilterListOptions = {
          render: (v) => {
            return v.toString() !== '' ? `${col.label}: ${v.toString()}` : [];
          },
          update: (filterList, filterPos, index) => {
            if (filterPos === 0) {
              filterList[index].splice(filterPos, 1, '');
            } else if (filterPos === 1) {
              filterList[index].splice(filterPos, 1);
            } else if (filterPos === -1) {
              filterList[index] = [];
            }
            return filterList;
          },
        };
        col.options.filterOptions = {
          logic: (value, filters) => {
            if (filters.length > 0 && filters[0] !== '') {
              return !filters.includes(value);
            }
            return false;
          },
          display: (filterList, onChange, index, column, filterData) => {
            return (
              <AutoCompleteFilter
                freeSolo={true}
                name={column.name}
                label={column.label}
                value={filterList[index][0] || ''}
                onChange={(event) => {
                  filterList[index][0] = event.currentTarget.value;
                  onChange(filterList[index], index, column);
                }}
                options={filterData[index]}
              />
            );
          },
        };
        col.options.customBodyRenderLite = (dataIndex) => {
          const value = rows[dataIndex][col.name];
          const formattedValue = getColumnValue(col.type, value);

          return (
            <div align="right" style={{ color: value < 0 && '#f44336' }}>
              {formattedValue}
            </div>
          );
        };

        col.options.sortCompare = tablePercentageSortCompare;
        break;
      case columnType.quantity:
        col.options.filterType = 'custom';
        col.options.customFilterListOptions = {
          render: (v) => {
            return v.toString() !== '' ? `${col.label}: ${v.toString()}` : [];
          },
          update: (filterList, filterPos, index) => {
            if (filterPos === 0) {
              filterList[index].splice(filterPos, 1, '');
            } else if (filterPos === 1) {
              filterList[index].splice(filterPos, 1);
            } else if (filterPos === -1) {
              filterList[index] = [];
            }
            return filterList;
          },
        };
        col.options.filterOptions = {
          logic: (value, filters) => {
            if (filters.length > 0 && filters[0] !== '') {
              return !filters.includes(value);
            }
            return false;
          },
          display: (filterList, onChange, index, column, filterData) => {
            return (
              <AutoCompleteFilter
                freeSolo={true}
                name={column.name}
                label={column.label}
                value={filterList[index][0] || ''}
                onChange={(event) => {
                  filterList[index][0] = event.currentTarget.value;
                  onChange(filterList[index], index, column);
                }}
                options={filterData[index]}
              />
            );
          },
        };
        col.options.customBodyRenderLite = (dataIndex) => {
          const value = rows[dataIndex][col.name];
          const formattedValue = getColumnValue(col.type, value);

          return (
            <div align="right" style={{ color: value < 0 && '#f44336' }}>
              {formattedValue}
            </div>
          );
        };

        col.options.sortCompare = tableQuantitySortCompare;
        break;

      case columnType.bool:
        col.options.customBodyRenderLite = (dataIndex) => {
          return <div>{rows[dataIndex][col.name] ? <CheckCircleIcon /> : null}</div>;
        };
        col.options.customFilterListOptions = {
          render: (v) => {
            return v.toString() !== '' ? `${col.label}: ${v.toString()}` : [];
          },
        };
        col.options.filterType = 'dropdown';
        col.options.filterOptions = {
          names: ['True', 'False'],
          logic(value, filters) {
            const show =
              (filters[0] === 'True' && value) ||
              (filters[0] === 'False' && value === false);

            return show;
          },
        };
        break;
      case columnType.status:
        col.options.customBodyRenderLite = (dataIndex) => {
          const value = rows[dataIndex][col.name];
          const formattedValue = getColumnValue(col.type, value);

          return <div align="right">{formattedValue}</div>;
        };
        break;
      case columnType.note:
        col.options.customBodyRenderLite = (dataIndex) => {
          let value = rows[dataIndex][col.name] ? rows[dataIndex][col.name] : '';
          if (value !== '') {
            const regex = /(<([^>]+)>)/gi;
            value = value?.replace(regex, '  ');
            value = value.replace(/\s{2,}/g, ' ').trim();
          }

          if (value?.length >= 100) {
            return value.substring(0, 150) + '...';
          }
          return value;
        };
        col.options.filterType = 'custom';
        col.options.customFilterListOptions = NoteCustomFilterListOptions(col);
        col.options.filterOptions = NoteFilterOptions;
        break;
      case columnType.list:
        col.options.customBodyRenderLite = (dataIndex) => {
          const value = rows[dataIndex][col.name];
          if (value != '') {
            const data = value.split(col.options.listSeparator);
            const items = [];
            for (const item of data) {
              if (!items.includes(item) && item.trim() !== '') {
                items.push(item);
              }
            }
            return items.map((item, index) => <div key={index}>{item}</div>);
          } else {
            return '';
          }
        };
        col.options.filterType = 'custom';
        col.options.customFilterListOptions = ListCustomFilterListOptions(col);
        col.options.filterOptions = ListFilterOptions(col.options.listSeparator);
        break;
      case columnType.time:
        col.options.customBodyRenderLite = (dataIndex) => {
          return getColumnValue(col.type, rows[dataIndex][col.name]);
        };
        break;
      case columnType.timeWithMilliseconds:
        col.options.customBodyRenderLite = (dataIndex) => {
          return getColumnValue(col.type, rows[dataIndex][col.name]);
        };
        break;
      case columnType.duration:
        col.options.customBodyRenderLite = (dataIndex) => {
          return getColumnValue(col.type, rows[dataIndex][col.name]);
        };
        break;
      case columnType.buttons:
        col.label = col.label ? col.label : 'Action Buttons';
        col.options = {
          ...{
            draggable: false,
            resizable: false,
            print: false,
            searchable: false,
            filter: false,
            sort: false,
            empty: true,
            viewColumns: false,
            download: false,
          },
          customHeadLabelRender: () => {
            return <div></div>;
          },
          setCellProps: () => {
            return {
              style: { padding: 1, width: 10 },
            };
          },
          ...col.options,
        };
        break;
      default:
        col.options.filterType = 'custom';
        col.options.customFilterListOptions = {
          render: (v) => {
            return v.toString() !== '' ? `${col.label}: ${v.toString()}` : [];
          },
          update: (filterList, filterPos, index) => {
            if (filterPos === 0) {
              filterList[index].splice(filterPos, 1, '');
            } else if (filterPos === 1) {
              filterList[index].splice(filterPos, 1);
            } else if (filterPos === -1) {
              filterList[index] = [];
            }
            return filterList;
          },
        };
        col.options.filterOptions = {
          logic: (value, filters) => {
            if (filters.length > 0 && filters[0] !== '') {
              return !filters.includes(value);
            }
            return false;
          },
          display: (filterList, onChange, index, column, filterData) => {
            if (filterData[index].includes('<nil>')) {
              filterData[index].map((i, idx) => {
                if (i === '<nil>') {
                  filterData[index][idx] = '';
                }
              });
            }
            return (
              <AutoCompleteFilter
                freeSolo={true}
                name={column.name}
                label={column.label}
                value={filterList[index][0] || ''}
                onChange={(event) => {
                  filterList[index][0] = event.currentTarget.value;
                  onChange(filterList[index], index, column);
                }}
                options={filterData[index]}
              />
            );
          },
        };
    }
    return col;
  });
};

const getCustomFilterListOptions = (col) => {
  return {
    render: (value) => {
      if (value[0] && value[1]) {
        return `From ${col.label}: ${value[0]}, To ${col.label}: ${value[1]}`;
      } else if (value[0]) {
        return `From ${col.label}: ${value[0]}`;
      } else if (value[1]) {
        return `To ${col.label}: ${value[1]}`;
      }
      return [];
    },
    update: (filterList, filterPos, index) => {
      if (filterPos === 0) {
        filterList[index].splice(filterPos, 1, '');
      } else if (filterPos === 1) {
        filterList[index].splice(filterPos, 1);
      } else if (filterPos === -1) {
        filterList[index] = [];
      }

      return filterList;
    },
  };
};

const getCsvFileName = (title) => {
  return title?.replace(/ /g, '') + '_' + moment().format('MMMM Do YYYY') + '.csv';
};

const dateRangeTemplate = (filterList, onChange, index, column, col, dateType) => (
  <div>
    <FormGroup row>
      <TextField
        label={'From ' + col.label}
        type={dateType}
        InputLabelProps={{ shrink: true }}
        value={filterList[index][0] || ''}
        onChange={(event) => {
          filterList[index][0] = event.target.value;
          onChange(filterList[index], index, column);
        }}
        style={{ width: '45%', marginRight: '5%' }}
        inputProps={{
          max: filterList[index][1],
        }}
      />
      <TextField
        label={'To ' + col.label}
        type={dateType}
        InputLabelProps={{ shrink: true }}
        value={filterList[index][1] || ''}
        onChange={(event) => {
          filterList[index][1] = event.target.value;
          onChange(filterList[index], index, column);
        }}
        style={{ width: '45%' }}
        inputProps={{
          min: filterList[index][0],
        }}
      />
    </FormGroup>
  </div>
);

const getOptionSettings = (
  options,
  columns,
  rows,
  title,
  columnOrder,
  setColumnOrder,
  visibleColumns,
  setVisibleColumns,
  rowsSelected,
  params,
  footerData,
  pagination,
  setPagination,
  setOpenCsvDownload,
  setFilterList,
  additionalCell,
  setServerSideSearch,
  clientSideRowsPerPage,
  setClientSideRowsPerPage,
  isFilterActive,
  setIsFilterActive,
  columnSettings,
  componentName,
  isReset,
  setIsReset
) => {
  const footerSettings = getFooterSettings(columns);

  let defaultSettings = {
    columnOrder: columnOrder,
    filterType: 'multiselect',
    responsive: 'standard',
    download: true,
    filter: true,
    search: true,
    print: false,
    sort: true,
    viewColumns: true,
    resizableColumns: false,
    draggableColumns: {
      enabled: true,
    },
    selectableRowsHeader: true,
    selectableRows: 'multiple',
    rowsSelected: rowsSelected,
    rowsPerPage: clientSideRowsPerPage,
    rowsPerPageOptions: [25, 50, 100, 500, 1000],
    downloadOptions: {
      filename: getCsvFileName(title),
    },
    fixedHeader: true,
    fixedSelectColumn: false,
    tableBodyHeight: title !== 'Locations' ? '400px' : 'auto',
    customSort: (data, colIndex, order) => {
      return data.sort((a, b) => {
        if (
          typeof a.data[colIndex] === 'object' &&
          typeof b.data[colIndex] === 'object' &&
          a.data[colIndex].seconds !== 0 &&
          b.data[colIndex].seconds !== 0
        ) {
          const valueA = new Date(a.data[colIndex].seconds * 1000)
            .toISOString()
            .substr(11, 8);
          const valueB = new Date(b.data[colIndex].seconds * 1000)
            .toISOString()
            .substr(11, 8);

          return (valueA < valueB ? -1 : 1) * (order === 'desc' ? 1 : -1);
        }

        return (
          (a.data[colIndex] < b.data[colIndex] ? -1 : 1) * (order === 'desc' ? 1 : -1)
        );
      });
    },
    onColumnOrderChange: (newColumnOrder) => {
      setColumnOrder(newColumnOrder);
      if (options.onColumnOrderChange) {
        options.onColumnOrderChange(newColumnOrder);
      }
    },
    customTableBodyFooterRender: function (opts) {
      return (
        <TableBodyFooter
          columnOrder={columnOrder}
          columns={opts.columns}
          columnsWithAmt={footerSettings.columnsWithAmt}
          columnsWithPrice={footerSettings.columnsWithPrice}
          columnsWithQty={footerSettings.columnsWithQty}
          columnsWithPercentage={footerSettings.columnsWithPercentage}
          rows={rows}
          selectableRows={options.selectableRows}
          additionalCell={additionalCell}
        ></TableBodyFooter>
      );
    },
    onViewColumnsChange: (changedColumn, action, updatedColumns) => {
      if (action === 'add') {
        setVisibleColumns([...visibleColumns, changedColumn]);
      } else if (action === 'remove') {
        let copy = [...visibleColumns];
        let index = copy.indexOf(changedColumn);
        copy.splice(index, 1);
        setVisibleColumns(copy);
      } else {
        setVisibleColumns(
          updatedColumns.reduce((filtered, col) => {
            if (col.name === '') {
              filtered.push(col.name); // buttons
            }

            if (col.display === 'true') {
              filtered.push(col.name);
            }

            return filtered;
          }, [])
        );
      }
    },
    customSearch: (searchQuery, currentRow, cols) => {
      const types = getColumnTypes(cols, columns);
      for (let i = 0; i < currentRow.length; i++) {
        const value = currentRow[i];
        if (!value) continue;
        const clearedValue = value.toString().replace(/(<([^>]+)>)/gi, '');
        if (typeof value === 'string') {
          if (clearedValue.toLowerCase().includes(searchQuery.toLowerCase())) return true;
        }
        const formattedValue = getColumnValue(types[i], value);
        const clearedFormattedValue = formattedValue
          .toString()
          .replace(/(<([^>]+)>)/gi, '');
        if (
          clearedFormattedValue
            .toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase())
        )
          return true;
      }
      return false;
    },
    onDownload: (buildHead, buildBody, cols, data) => {
      const types = getColumnTypes(cols, columns);
      const body = data.map((row) => {
        row.data = row.data.map((value, index) => {
          return getColumnValue(types[index], value);
        });
        return row;
      });
      return '\uFEFF' + buildHead(cols) + buildBody(body).replace(/"'/g, '"');
    },
    customToolbar: function () {
      return (
        <Fragment>
          <Tooltip title="Save Table" arrow>
            <IconButton
              onClick={() => {
                updateTableSettings({
                  ...params,
                  visibleColumns: visibleColumns,
                  columnOrder: columnOrder,
                })
                  .then(() => {
                    notifySuccess('Table has been saved.');
                  })
                  .catch((err) => {
                    console.log(err.message);
                    if (err.message.includes('not found')) {
                      notifySuccess('Table has been saved.');
                    }
                  });
              }}
            >
              <SaveIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Reset Grid" arrow>
            <IconButton
              onClick={() => {
                const deleteSettings = deleteTableSettings(params);
                deleteSettings
                  .then(() => {
                    setIsReset(true);
                  })
                  .catch(() => {
                    console.error('error deleting table setting');
                  });
              }}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>
        </Fragment>
      );
    },
  };

  const onTableChange = (action, tableState) => {
    switch (action) {
      case 'changePage':
        setPagination({
          ...pagination,
          pageNo: tableState.page,
          reload: true,
        });
        break;
      case 'changeRowsPerPage': {
        setPagination({
          ...pagination,
          rowsPerPage: tableState.rowsPerPage,
          reload: true,
          pageNo: 0,
        });
        break;
      }
      case 'sort':
        setPagination({
          ...pagination,
          sortDirection: tableState.sortOrder.direction,
          sortName: tableState.sortOrder.name,
          reload: true,
        });
        break;
      case 'filterChange':
        {
          let filterNames = [];
          let filterValues = [];

          let reloadGrid = false;

          tableState.filterList.forEach((item, index) => {
            if (item.length && item.toString() !== '') {
              if (item[0] !== undefined || item[0] !== '') {
                filterNames.push(tableState.columns[index].name);
                filterValues.push(item[0]);
                reloadGrid = true;
              }
            }
          });

          setIsFilterActive(true);

          if (
            tableState.filterList.find((v) => v.length && v.toString() !== '') !==
            undefined
          ) {
            setIsFilterActive(true);
          } else {
            setIsFilterActive(false);
          }

          if (pagination.filterNames) {
            if (pagination.filterNames.length === 1) {
              reloadGrid = true;
            }
          }

          //if (rows?.length > 0) {
          setPagination({
            ...pagination,
            sortDirection: tableState.sortOrder.direction,
            sortName: tableState.sortOrder.name,
            filterNames: filterNames,
            filterValues: filterValues,
            reload: reloadGrid,
          });
          //}
        }
        break;
      case 'search':
        if (options.serverSide) {
          setIsFilterActive(true);
          setServerSideSearch(tableState.searchText);

          if (
            tableState.searchText === null ||
            tableState.searchText === '' ||
            tableState.searchText === undefined
          ) {
            setIsFilterActive(false);
          }
        }
        break;
      case 'resetFilters':
        {
          let filter = {};

          tableState.filterList.forEach((item, index) => {
            if (item.length && item.toString() !== '') {
              filter[tableState.columns[index].name] = item[''];
            }
          });

          setFilterList(filter);
          setIsFilterActive(false);
        }
        break;
      default:
    }
  };

  const onTableChangeClientSide = (action, tableState) => {
    switch (action) {
      case 'changeRowsPerPage':
        setClientSideRowsPerPage(tableState.rowsPerPage);
        break;
      case 'filterChange':
        {
          let filter = {};

          tableState.filterList.forEach((item, index) => {
            if (item.length && item.toString() !== '') {
              if (item[0] !== undefined || item[0] !== '') {
                filter[tableState.columns[index].name] = item[0];
              }
            }
          });

          if (
            tableState.filterList.find((v) => v.length && v.toString() !== '') !==
            undefined
          ) {
            setIsFilterActive(true);
          } else {
            setIsFilterActive(false);
          }

          setFilterList(filter);
        }
        break;
      default:
    }
  };

  if (options.serverSide) {
    defaultSettings.customSearch = undefined;
    defaultSettings.onDownload = () => {
      setOpenCsvDownload(true);
      return false;
    };
    defaultSettings.filterType = 'dropdown';
    defaultSettings.count = pagination.count;
    defaultSettings.page = pagination.pageNo;
    defaultSettings.rowsPerPage = pagination.rowsPerPage;
    defaultSettings.onTableChange = onTableChange;
    defaultSettings.customTableBodyFooterRender = function (opts) {
      if (!footerData) return null;
      return (
        <ServerSideTableBodyFooter
          columnOrder={columnOrder}
          columns={opts.columns}
          columnsWithAmt={footerSettings.columnsWithAmt}
          columnsWithPrice={footerSettings.columnsWithPrice}
          columnsWithQty={footerSettings.columnsWithQty}
          columnsWithPercentage={footerSettings.columnsWithPercentage}
          rows={rows}
          data={footerData}
          isFilterActive={isFilterActive}
          additionalCell={additionalCell}
        ></ServerSideTableBodyFooter>
      );
    };
  }

  if (options.clientSideTableListener) {
    defaultSettings.onTableChange = onTableChangeClientSide;
  }

  if (
    (!options.clientSideTableListener || options.clientSideTableListener === '') &&
    (!options.serverSide || options.serverSide === '')
  ) {
    defaultSettings.onTableChange = onTableChangeClientSide;
  }

  if (!options) {
    return defaultSettings;
  }

  return { ...defaultSettings, ...options };
};

const getColumnTypes = (currentColumnSettings, baseColumnSettings) => {
  return currentColumnSettings.map((col) => {
    const columnSetting = getColumnSettingsByName(baseColumnSettings, col.name);
    return columnSetting.type;
  });
};

export const getColumnValue = (type, value) => {
  switch (type) {
    case columnType.date: {
      const retValue = formatPbDate(value);
      return retValue !== '00/00/00' ? retValue : '';
    }
    case columnType.dateTime:
      return !['', undefined, null].includes(value)
        ? protoTimeSpanObjectToString(value, 'MM/DD/YYYY hh:mm:ss a')
        : '--';
    case columnType.quantity:
      return formatQty(value);
    case columnType.percentage:
      return formatPercentage(value);
    case columnType.amount:
      return formatCurrency(value);
    case columnType.amountCurrency:
      return formatCurrencySymbol(value);
    case columnType.price:
      return formatCurrency(value, 6);
    case columnType.priceCurrency:
      return formatCurrencySymbol(value, '', 6);
    case columnType.amountBalance:
      return formatCurrencySymbol(value);
    case columnType.status:
      return formatStatus(value);
    case columnType.note:
      return value;
    case columnType.list:
      return value;
    case columnType.time:
      return twelveHourTimeFormat(value);
    case columnType.timeWithMilliseconds: {
      const retVal = protoDatTimeObjectToDateWithMilliseconds(value);
      if (retVal != '00:00:00.0000000') {
        return retVal;
      } else {
        return '--:--:--';
      }
    }
    case columnType.duration:
      return formatDuration(value);
    case columnType.text:
    case '':
    case columnType.buttons:
    case undefined:
      return value;
    default:
      break;
  }

  return value;
};

const getFooterSettings = (columns) =>
  columns.reduce(
    (settings, col) => {
      if (col.addFooter)
        switch (col.type) {
          case columnType.amount:
            settings.columnsWithAmt.push(col.name);
            break;
          case columnType.price:
            settings.columnsWithPrice.push(col.name);
            break;
          case columnType.percentage:
            settings.columnsWithPercentage.push(col.name);
            break;
          case columnType.quantity:
            settings.columnsWithQty.push(col.name);
            break;
          default:
            console.error(
              "cannot add custom footer, object have invalid 'type' property"
            );
            break;
        }

      return settings;
    },
    {
      columnsWithAmt: [],
      columnsWithPrice: [],
      columnsWithQty: [],
      columnsWithPercentage: [],
    }
  );

const getColumnOrder = (columns, columnsSettings) =>
  columns.map((col) => {
    return getArrayKeyIndex(columnsSettings, col.name, 'name');
  });

const getColumnSettingsByName = (columnsSettings, name) => {
  const index = getArrayKeyIndex(columnsSettings, name, 'name');
  return columnsSettings[index];
};

const sortColumnSettings = (columns) =>
  columns.sort(function (a, b) {
    if (a.name.toLowerCase() < b.name.toLowerCase()) {
      return -1;
    }
    if (a.name.toLowerCase() > b.name.toLowerCase()) {
      return 1;
    }
    return 0;
  });

const showAllColumns = (col, setVisibleColumns) => {
  const showColumns = col.reduce((filtered, col) => {
    if (col.type === 'buttons') {
      filtered.push(col.name);
    }
    if (
      !col.options.hidden &&
      (col.options === undefined ||
        col.options.display === undefined ||
        col.options.display === false ||
        col.options.display === 'false')
    ) {
      col.options.display = true;
      filtered.push(col.name);
    }

    return filtered;
  }, []);

  setVisibleColumns(showColumns);
};

const serverSideCustomSearch = (searchQuery, rows, visibleColumns, sortedColumns) => {
  const columnTypes = {};

  sortedColumns.forEach((col) => {
    col.options = col.options || {};
    if (visibleColumns.includes(col.name)) {
      col.options.display = true;
      columnTypes[col.name] = col?.type;
    }

    return col;
  });

  const keys = Object.keys(columnTypes);

  return rows.filter((r) => {
    for (let index = 0; index < keys.length; index++) {
      const colName = keys[index];
      const value = r[colName];
      if (!value) {
        continue;
      }

      if (typeof value === 'string') {
        if (value.toLowerCase().includes(searchQuery?.toLowerCase())) {
          return true;
        }
      }
      const formattedValue = getColumnValue(columnTypes[colName], value);
      if (formattedValue?.toString().toLowerCase().includes(searchQuery?.toLowerCase())) {
        return true;
      }
    }
    return false;
  });
};
